import styled from "styled-components"
import { Button } from "../../../../parts/buttons/button"

export const SurveyWrapper = styled.section`
  padding: 16px;
  width: 100%;
  max-width: 480px;
`

export const Buttons = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
  max-width: 250px;
  margin: 32px auto 0;
`

export const StyledButton = styled(Button)`
  width: 100px;
`
